import { render, staticRenderFns } from "./chart-garbage-kp.vue?vue&type=template&id=28fb7f4c&"
import script from "./chart-garbage-kp.vue?vue&type=script&lang=js&"
export * from "./chart-garbage-kp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports